<app-kontable
        id="dt_stores_group_details"
        title = "{{ 'store.store_groups' | translate }} : {{store_group.name}}"
        [columns] = "['id', 'code', 'host_code', 'name', 'short_name', 'city', 'description', 'region']"
        [titles] = "['common.id', 'common.code', 'common.host_code', 'common.name', 'common.short_name', 'common.city', 'common.description', 'common.region']"
        [showInfoButton]="false"
        [showRecoverButton]="true"
        [showGlobalFilter]="false"
        [showDetailsButton]="false"
        [showAddButton]="true"
        [source]="svc.list_filtered_groups"
        [konPermissions]="perm"
        (onAdd)="showStoreSelection = true"
        (onEdit)="showAddOrEditDialog($event)"
        (onRemove)="delete($event)">
</app-kontable>

<p-dialog
    id="store-selection-dialog"
    [(visible)]="showStoreSelection"
    header="Selezionare un Negozio"
    [responsive]="true"
    showEffect="fade"
    [modal]="true"
>
  <app-store-selection-table (onStoreSelect)="addStore($event)"></app-store-selection-table>
</p-dialog>

<p-dialog *ngIf="showDetail"
          [width]="600"
          header="{{modalTitle}}"
          [(visible)]="showDetail"
          [responsive]="true"
          showEffect="fade"
          [modal]="true"
          (onHide)="onDialogHide()">

  <app-store-group-details-form
          [editingElement]="svc.editing_store_group_detail"
          (onAddElement)="saveDetail($event)">
  </app-store-group-details-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-group/store-group-details/store-group-details.component.html